// frontend/klaes-app/src/components/FilmFavs/hooks/useFilmFavsAPI.js
import { useCallback } from 'react';
import { useAuth } from '../../../contexts/AuthContext';

// Verwende die gleiche BASE wie in api.js
const API_BASE = 'http://klaes.info';

// Hilfsfunktion für authentifizierte Requests
const authFetch = async (url, options = {}, token) => {
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers,
      },
    });
    
    const text = await response.text();
    
    if (!text || text.trim() === '') {
      if (response.ok) {
        return [];
      }
      throw new Error('Leere Antwort vom Server');
    }
    
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error('JSON Parse Error:', text.substring(0, 200));
      throw new Error('Ungültige JSON-Antwort vom Server');
    }
    
    if (!response.ok) {
      throw new Error(data.error || 'Ein Fehler ist aufgetreten');
    }
    
    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

export const useFavsAPI = (apiPath = '/api/film-favs') => {
  const { token } = useAuth();

  const fetchEntries = useCallback(async () => {
    return await authFetch(`${API_BASE}${apiPath}/entries`, {}, token);
  }, [apiPath, token]);

  const addEntry = async (entryData, initialRating, currentUser) => {
    return await authFetch(`${API_BASE}${apiPath}/entries`, {
      method: 'POST',
      body: JSON.stringify({ ...entryData, initialRating, currentUser }),
    }, token);
  };

  const updateEntry = async (id, updatedData, newRating, currentUser) => {
    return await authFetch(`${API_BASE}${apiPath}/entries/${id}`, {
      method: 'PUT',
      body: JSON.stringify({ ...updatedData, newRating, currentUser }),
    }, token);
  };

  const deleteEntry = async (id) => {
    return await authFetch(`${API_BASE}${apiPath}/entries/${id}`, {
      method: 'DELETE',
    }, token);
  };

  const fetchTags = useCallback(async () => {
    return await authFetch(`${API_BASE}${apiPath}/tags`, {}, token);
  }, [apiPath, token]);

  const createTag = async (newTag) => {
    return await authFetch(`${API_BASE}${apiPath}/tags`, {
      method: 'POST',
      body: JSON.stringify(newTag),
    }, token);
  };

  return { fetchEntries, addEntry, updateEntry, deleteEntry, fetchTags, createTag };
};

export const useFilmFavsAPI = () => useFavsAPI('/api/film-favs');